import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d9c2bb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-content-inner box has-background-grey-dark" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-wrap" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title mb-3" }, "Orders List")
], -1))
const _hoisted_3 = { class: "column is-12" }
const _hoisted_4 = { class: "title is-4" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-copy has-text-info",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_6 = { class: "panel has-background-grey-dark" }
const _hoisted_7 = { class: "panel-heading has-background-grey-dark has-text-light is-fullwidth pb-0" }
const _hoisted_8 = { class: "panel-block" }
const _hoisted_9 = { class: "table is-fullwidth has-background-secondary" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-book",
    "aria-hidden": "true"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SidebarLayout = _resolveComponent("SidebarLayout")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_SidebarLayout, { theme: "labels-hover" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getOrderData(), (order) => {
            return (_openBlock(), _createElementBlock("div", {
              key: order.username,
              class: "columns s-card m-0 orders-row"
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h2", _hoisted_4, [
                  _createTextVNode(_toDisplayString(order.username) + " ", 1),
                  _hoisted_5
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.strategies, (strat) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: strat.strategy,
                  class: "column is-6"
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("p", _hoisted_7, _toDisplayString(strat.strategy) + " - (" + _toDisplayString(strat.midval) + ") ", 1),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("table", _hoisted_9, [
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(strat.sbarray, (sb) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: sb.score,
                              class: _normalizeClass(["has-text-dark", _ctx.getSbClass(sb.sellbuy)])
                            }, [
                              _hoisted_10,
                              _createElementVNode("td", null, _toDisplayString(sb.sellbuy), 1),
                              _createElementVNode("td", null, _toDisplayString(sb.mid), 1),
                              _createElementVNode("td", null, _toDisplayString(sb.sbchar), 1),
                              _createElementVNode("td", null, _toDisplayString(sb.score), 1)
                            ], 2))
                          }), 128))
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ]))
          }), 128))
        ])
      ]),
      _: 1
    })
  ]))
}